import httpRequest from '../../utils/httpRequest'
import { setLoading } from '../global/action'

export const SET_BLOCK_FEE_HISTORY = 'SET_BLOCK_FEE_HISTORY'

export const SET_FEES = 'SET_FEES'

export const setBlockFeeHistory = data => dispatch => {
  dispatch({ type: SET_BLOCK_FEE_HISTORY, data })
}

export const setFees = data => dispatch => {
  dispatch({ type: SET_FEES, data })
}

export const getBlockFees = params => async dispatch => {
  try {
    dispatch(setLoading(true))
    const data = await httpRequest.getBlockExchangeFees(params)
    dispatch(setBlockFeeHistory(data))
    dispatch(setLoading(false))
  } catch (err) {
    console.log(`status:${err.status} message: ${err.statusText}`)
    dispatch(setLoading(false))
  }
}

export const getFees = () => async dispatch => {
  try {
    const fees = await httpRequest.getFees()
    dispatch(setFees(fees))
  } catch (err) {
    console.log(`status:${err.status} message: ${err.statusText}`)
  }
}
